import React from 'react';

// Web: native HTML date/time input — matches the DateTimePicker API used in App.js
export default function DateTimePicker({ value, onChange, mode = 'date' }) {
  const toInputValue = (d) => {
    if (!(d instanceof Date) || isNaN(d)) return '';
    if (mode === 'time') {
      return d.toTimeString().slice(0, 5); // HH:MM
    }
    return d.toISOString().split('T')[0]; // YYYY-MM-DD
  };

  const handleChange = (e) => {
    if (!e.target.value) return;
    let d;
    if (mode === 'time') {
      const [h, m] = e.target.value.split(':');
      d = new Date(value instanceof Date ? value : new Date());
      d.setHours(parseInt(h, 10), parseInt(m, 10), 0, 0);
    } else {
      d = new Date(e.target.value + 'T12:00:00');
    }
    onChange({}, d);
  };

  return (
    <input
      type={mode === 'time' ? 'time' : 'date'}
      value={toInputValue(value)}
      onChange={handleChange}
      style={{
        fontSize: 15,
        padding: '10px 14px',
        borderRadius: 8,
        border: '1px solid #EAE4DA',
        backgroundColor: '#FFFFFF',
        color: '#1A1A1A',
        width: '100%',
        marginBottom: 12,
        boxSizing: 'border-box',
        outline: 'none',
        cursor: 'pointer',
      }}
    />
  );
}
